import { Overline, Card } from "./shared";

export const FinanceResult = ({ r }) => (
  <div data-testid="bb-result-finance" className="grid grid-cols-1 lg:grid-cols-2 gap-5">
    <Card>
      <Overline>Startup costs</Overline>
      <ul className="divide-y divide-black/15">
        {(r.startup_costs || []).map((c) => (
          <li key={c.item} className="flex justify-between py-2 text-sm">
            <span>{c.item}</span><span className="font-mono">{c.cost}</span>
          </li>
        ))}
      </ul>
      <div className="font-mono text-xs text-[#52525b] mt-3">Pricing: {r.pricing_assumption}</div>
    </Card>
    <Card>
      <Overline>Unit economics</Overline>
      <div className="grid grid-cols-2 gap-px bg-black border border-black">
        {Object.entries(r.unit_economics || {}).map(([k, v]) => (
          <div key={k} className="bg-white p-3">
            <div className="font-mono text-[10px] text-[#52525b] uppercase">{k.replace(/_/g, " ")}</div>
            <div className="font-display font-extrabold text-xl">{v}</div>
          </div>
        ))}
      </div>
      <div className="mt-3 text-sm"><b>Break-even:</b> {r.break_even}</div>
    </Card>
    <Card className="lg:col-span-2">
      <Overline>Forecast</Overline>
      <div className="grid grid-cols-3 gap-px bg-black border border-black">
        {(r.forecast || []).map((f) => (
          <div key={f.period} className="bg-white p-4">
            <div className="font-mono text-[10px] text-[#52525b]">{f.period}</div>
            <div className="font-display font-extrabold text-2xl mt-1">{f.mrr}</div>
            <div className="font-mono text-xs text-[#52525b]">{f.customers} customers · profit {f.profit}</div>
          </div>
        ))}
      </div>
      <div className="font-mono text-xs text-[#ff3b30] mt-3">⚠ {r.biggest_risk}</div>
    </Card>
  </div>
);
